import "../index.css";
import { ValuationsLandingPage } from "./valuations-landing-page.tsx";
import { reactHydrate } from "../react-hydrate.ts";

window.Components = {
  ValuationsLandingPage: ValuationsLandingPage,
};

reactHydrate();
